export enum SearchPanelSectionsIds {
    SUMMARY = 'summary',
    VI_PAGE_FILTERS = 'vi_page_filters',
    VI_COMPANY_PROFILE = 'vi_company_profile',
    VI_IN_MARKET_SIGNALS = 'vi_in_market_signals',
    VI_MORE = 'vi_more',
    COMPANY_PROFILE = 'company_profile',
    IN_MARKET_SIGNALS = 'in_market_signals',
    BUYER_PERSONA = 'buyer_persona',
    MORE = 'more',    
}
